import React from 'react';

export type IconName =
  | 'sync'
  | 'refresh'
  | 'add'
  | 'logout'
  | 'teacher'
  | 'assignments'
  | 'stats'
  | 'student'
  | 'archive'
  | 'photo';

const icons: Record<IconName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  sync: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M21 12a9 9 0 10-3.1 6.45" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21 3v6h-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  refresh: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M20 12a8 8 0 10-2.2 5.3L21 20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21 3v6h-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  add: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  logout: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M16 17l5-5-5-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 19H7a2 2 0 01-2-2V7a2 2 0 012-2h3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  teacher: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 12a4 4 0 100-8 4 4 0 000 8z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  assignments: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <path d="M8 8h8M8 12h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  stats: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3 3v18h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M7 14v4M12 10v8M17 6v12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  student: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 7a4 4 0 100-8 4 4 0 000 8z" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M3 21v-2a5 5 0 015-5h8a5 5 0 015 5v2" stroke="currentColor" strokeWidth="1.4"/>
    </svg>
  ),
  archive: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect x="3" y="3" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="1.6"/>
      <path d="M21 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V7" stroke="currentColor" strokeWidth="1.6"/>
      <path d="M10 12h4" stroke="currentColor" strokeWidth="1.6"/>
    </svg>
  ),
  photo: (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6"/>
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6"/>
    </svg>
  ),
};

export default function Icon({ name, size = 18, color = 'currentColor', ...rest }: { name: IconName; size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
  const Svg = icons[name];
  return <Svg width={size} height={size} style={{ color }} aria-hidden="true" focusable="false" {...rest} />;
}
